import { useEffect, RefObject } from 'react';

type AnyEvent = MouseEvent | TouchEvent;

function useOutsideClick<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: (event: AnyEvent) => void,
  buttonRef?: RefObject<HTMLElement>
): void {
  useEffect(() => {
    const listener = (event: AnyEvent) => {
      const el = ref.current;
      const buttonEl = buttonRef?.current;

      if (!el || el.contains(event.target as Node) || (buttonEl && buttonEl.contains(event.target as Node))) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, buttonRef]);
}

export default useOutsideClick;
